module.exports = __webpack_public_path__ + "img/lisa_s_2.744e6ee4.png";